import React, {Component} from "react"
import Header from "./Header"
import HomePage from "./HomePage"
import Login from "./Login"
import SignUp from "./SignUp"
import {BrowserRouter as Router, Switch, Route} from "react-router-dom"

class Home extends Component {
	constructor () {
		super()
		this.state = {}
	}
	render () {
		return (
			<Router>
				<Header />
				<Switch>
					<Route path="/" exact component={HomePage} />
					<Route path="/login" exact component={Login} />
					<Route path="/signup" exact component={SignUp} />
				</Switch>
			</Router>
		)
	}
}

export default Home